import { render, staticRenderFns } from "./user-index.vue?vue&type=template&id=be931d82&scoped=true"
import script from "./user-index.vue?vue&type=script&lang=js"
export * from "./user-index.vue?vue&type=script&lang=js"
import style0 from "./user-index.vue?vue&type=style&index=0&id=be931d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be931d82",
  null
  
)

export default component.exports